export default __webpack_public_path__ + "static/media/lalamove_lorry.8fea489b.png";